import React from "react";
import { Box, Card, CardContent, Typography, Button } from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";

const WishlistSuccessAlert = ({ message, onClose }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        p:2,
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: 340,
          borderRadius: 4,
          textAlign: "center",
          p: 3,
        }}
        elevation={10}
      >
        <CardContent>
          <FavoriteIcon
            sx={{
              fontSize: 70,
              color: "red",
              mb: 2,
            }}
          />

          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Wishlist Updated
          </Typography>

          <Typography variant="body2" color="text.secondary" mb={3}>
            {message}
          </Typography>

          <Button
            variant="contained"
            color="success"
            fullWidth
            onClick={onClose}
            sx={{ borderRadius: 3 }}
          >
            OK
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default WishlistSuccessAlert;